import ShwLink, { type ShwLinkProps } from '@/components/ShwLink'

export default function OptionalLink({
  href,
  children,
  ...props
}: React.PropsWithChildren<
  { href?: string | null } & Omit<ShwLinkProps, 'href'>
>): React.ReactNode {
  return href == null ? (
    children
  ) : (
    <ShwLink href={href} {...props}>
      {children}
    </ShwLink>
  )
}
